import { TranslateFn, cn } from "@garther/ui/libs";
import { memo } from "react";

interface Props {
  className?: string;
  t: TranslateFn;
}

const FeaturedEventsEmpty = memo(({ className, t }: Props) => {
  return (
    <div className={cn("space-y-6", className)}>
      <div className="text-center text-text-secondary">
        <p>{t("home.featuredEvents.noEvents")}</p>
      </div>
    </div>
  );
});

FeaturedEventsEmpty.displayName = "FeaturedEventsEmpty";
export default FeaturedEventsEmpty;
